<template>
    <select-label
        v-model="event"
        :disabled="isDisabled"
        :editable="isEditable"
        :items="events"
        :label="label"
        :append-icon="isDisabled ? '' : '$vuetify.icons.dropdown'"
        item-text="text"
        item-value="value"
    />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { AppContext } from '../../store/context';
const Events = AppContext.SystemChangeHistoryEvent;
import SelectLabel from './SelectLabel.vue';

@Component({
    name: 'SelectorSystemChangeHistoryEvent',
    components: {
        SelectLabel,
    },
})
export default class SelectorSystemChangeHistoryEvent extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: undefined }) label: string;
    @Watch('value', { immediate: true })
    onValueChanged(val: string): void {
        this.event = val;
    }
    @Watch('event', { immediate: true })
    onEventChanged(val: string): void {
        this.input(val);
    }
    @Emit()
    public input(value: string) {}

    events = [];
    event = '';

    created() {
        this.events = [{ text: '', value: '' }].concat(
            Events.map(kv => {
                return { text: (this as any).$t(kv.text_key), value: kv.value };
            })
        );
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get isEditable(): boolean {
        return this.editable;
    }
}
</script>
